
import React from "react";
import { Progress } from "@/components/ui/progress";
import { HiringStage } from "@/lib/types";
import { CheckCircle2 } from "lucide-react";

interface StaffProgressProps {
  staffStages: HiringStage[];
  currentStage: number;
  progress: number;
}

const StaffProgress: React.FC<StaffProgressProps> = ({
  staffStages,
  currentStage,
  progress,
}) => {
  return (
    <div className="mb-8">
      <Progress value={progress} className="h-2 mb-6" />
      
      <div className="grid grid-cols-3 gap-2">
        {staffStages.map((stage, index) => {
          const isActive = index === currentStage;
          const isCompleted = index < currentStage;
          
          return (
            <div
              key={stage.id}
              className={`flex flex-col items-center text-center transition-all duration-300 ${
                isActive ? "scale-105" : ""
              }`}
            >
              <div
                className={`w-9 h-9 rounded-full mb-2 flex items-center justify-center border-2 transition-colors ${
                  isActive
                    ? "border-primary bg-primary/10 text-primary"
                    : isCompleted
                    ? "border-green-500 bg-green-100 dark:bg-green-900/20 text-green-600 dark:text-green-400"
                    : "border-gray-300 bg-gray-100 dark:bg-gray-800 text-gray-400"
                }`}
              >
                {isCompleted ? (
                  <CheckCircle2 className="h-5 w-5" />
                ) : (
                  <span className="text-sm font-medium">{index + 1}</span>
                )}
              </div>
              <h4
                className={`text-sm font-medium ${
                  isActive
                    ? "text-primary"
                    : isCompleted
                    ? "text-green-600 dark:text-green-400"
                    : "text-gray-500"
                }`}
              >
                {stage.title}
              </h4>
              <p
                className={`text-xs mt-1 ${
                  isActive
                    ? "text-gray-700 dark:text-gray-300"
                    : "text-gray-500 dark:text-gray-400"
                }`}
              >
                {stage.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StaffProgress;
